import apiPdca from '../../../../helpers/apiPdca'
import {
  loading,
  loaded,
  modalAlertaInfo,
  modalAlertaClean
} from '../../../../layout/redux/layoutActions'

import {
  AGIRACT_FETCH_REQUEST,
  AGIRACT_FETCH_SUCCESS,
  AGIRACT_FETCH_FAILURE,
  AGIRACT_SUBMIT_REQUEST,
  AGIRACT_SUBMIT_SUCCESS,
  AGIRACT_SUBMIT_FAILURE,
  AGIRACT_CAUSAS_REQUEST,
  AGIRACT_CAUSAS_SUCCESS,
  AGIRACT_CAUSAS_FAILURE,
  AGIRACT_CLEAR
} from './agiractReducer'

const abrirErroPadrao = (dispatch, nlsPopup) => {
  dispatch(
    modalAlertaInfo({
      ...nlsPopup[7],
      btnAction: () => dispatch(modalAlertaClean()),
      show: true
    })
  )
}

export const fetchAgirAct = planoId => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch({ type: AGIRACT_FETCH_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.get(`/pdca/planos/detalheplano?planoId=${planoId}`)
      const data = response?.data

      if (!data?.ok) {
        throw new Error('Erro ao carregar agir act.')
      }

      dispatch({
        type: AGIRACT_FETCH_SUCCESS,
        payload: data
      })
    } catch (error) {
      dispatch({
        type: AGIRACT_FETCH_FAILURE,
        payload: error?.message || 'Erro ao carregar agir act.'
      })

      abrirErroPadrao(dispatch, nlsPopup)
    } finally {
      dispatch(loaded())
    }
  }
}

export const fetchListaCausasFalha = () => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch({ type: AGIRACT_CAUSAS_REQUEST })

    try {
      const response = await apiPdca.get('/pdca/listacausasfalha')
      const data = Array.isArray(response?.data) ? response.data : []

      const options = data.map(item => ({
        label: item?.titulo || '',
        value: item?.causaFalhaId,
        raw: item
      }))

      dispatch({
        type: AGIRACT_CAUSAS_SUCCESS,
        payload: options
      })

      return options
    } catch (error) {
      dispatch({
        type: AGIRACT_CAUSAS_FAILURE,
        payload: error?.message || 'Erro ao carregar causas de falha.'
      })

      abrirErroPadrao(dispatch, nlsPopup)
      return []
    }
  }
}

export const submitPadronizarAct = ({ planoId, comentario }) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch({ type: AGIRACT_SUBMIT_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.post('/pdca/padronizaract', {
        planoId,
        comentario
      })

      const data = response?.data

      if (!data?.ok) {
        throw new Error('Erro ao padronizar act.')
      }

      dispatch({
        type: AGIRACT_SUBMIT_SUCCESS,
        payload: data
      })

      return { ok: true, data }
    } catch (error) {
      dispatch({
        type: AGIRACT_SUBMIT_FAILURE,
        payload: error?.message || 'Erro ao padronizar act.'
      })

      abrirErroPadrao(dispatch, nlsPopup)
      return { ok: false }
    } finally {
      dispatch(loaded())
    }
  }
}

export const submitPivotarAct = ({ planoId, causaFalhaId, comentario }) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch({ type: AGIRACT_SUBMIT_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.post('/pdca/pivotaract', {
        planoId,
        causaFalhaId,
        comentario
      })

      const data = response?.data

      if (!data?.ok) {
        throw new Error('Erro ao pivotar act.')
      }

      dispatch({
        type: AGIRACT_SUBMIT_SUCCESS,
        payload: data
      })

      return { ok: true, data }
    } catch (error) {
      dispatch({
        type: AGIRACT_SUBMIT_FAILURE,
        payload: error?.message || 'Erro ao pivotar act.'
      })

      abrirErroPadrao(dispatch, nlsPopup)
      return { ok: false }
    } finally {
      dispatch(loaded())
    }
  }
}

export const submitEscalonarAct = ({ planoId, causaFalhaId, comentario }) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch({ type: AGIRACT_SUBMIT_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.post('/pdca/escalonaract', {
        planoId,
        causaFalhaId,
        comentario
      })

      const data = response?.data

      if (!data?.ok) {
        throw new Error('Erro ao escalonar act.')
      }

      dispatch({
        type: AGIRACT_SUBMIT_SUCCESS,
        payload: data
      })

      return { ok: true, data }
    } catch (error) {
      dispatch({
        type: AGIRACT_SUBMIT_FAILURE,
        payload: error?.message || 'Erro ao escalonar act.'
      })

      abrirErroPadrao(dispatch, nlsPopup)
      return { ok: false }
    } finally {
      dispatch(loaded())
    }
  }
}

export const submitEncerrarAct = ({ planoId, causaFalhaId, comentario }) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch({ type: AGIRACT_SUBMIT_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.post('/pdca/encerraract', {
        planoId,
        causaFalhaId,
        comentario
      })

      const data = response?.data

      if (!data?.ok) {
        throw new Error('Erro ao encerrar act.')
      }

      dispatch({
        type: AGIRACT_SUBMIT_SUCCESS,
        payload: data
      })

      return { ok: true, data }
    } catch (error) {
      dispatch({
        type: AGIRACT_SUBMIT_FAILURE,
        payload: error?.message || 'Erro ao encerrar act.'
      })

      abrirErroPadrao(dispatch, nlsPopup)
      return { ok: false }
    } finally {
      dispatch(loaded())
    }
  }
}

export const clearAgirAct = () => {
  return {
    type: AGIRACT_CLEAR
  }
}